<template>
	<div class="upload-wrapper">
		<div v-if="label" class="upload-label">{{ label }}</div>
		<div class="uploaded-file" :class="{ 'upload-content-padding': label }">
			<input :accept="accepted" @change="fileChange" class="file-input" ref="fileInput" type="file" />
			<template v-if="!uploadInProgress">
				<v-btn @click="uploadClick" depressed icon v-if="fileData.upload_id === null && !readonly">
					<v-icon small>fa-upload</v-icon>
				</v-btn>
				<v-btn @click="downloadClick" depressed icon v-if="fileData.upload_id !== null">
					<v-icon small>fa-download</v-icon>
				</v-btn>
				<v-btn @click="deleteClick" depressed icon v-if="fileData.upload_id !== null && !readonly">
					<v-icon small>fa-trash</v-icon>
				</v-btn>
				{{ fileData.original_name }}
			</template>
			<div
				style="min-width: 220px"
				@dragover.prevent
				@drop.prevent="dropFiles"
				class="files-drop"
				v-cloak
				v-if="fileData.upload_id === null && !readonly"
			>
				<v-icon small>fas fa-copy</v-icon>
				{{ $t('labels.dragdropSingle') }}
			</div>
			<div v-if="uploadInProgress">
				{{ $t('labels.uploadInProgress') }}
			</div>
		</div>
	</div>
</template>

<style scoped>
.file-input {
	display: none;
}
.files-drop {
	border: 1px solid #d5d5d5;
	padding: 10px;
	width: 100%;
	height: 40px;
	max-width: 200px;
	text-align: center;
	display: inline-block;
}

.upload-wrapper {
	border-radius: 4px;
	border: 1px solid #9e9e9e;
	padding: 10px;
	margin-top: 3px;
}

.upload-wrapper:hover {
	border: 1px solid #242424;
}

.upload-label {
	left: 0;
	top: -22px;
	height: 15px;
	line-height: 15px;
	padding-left: 2px;
	padding-right: 2px;
	font-size: 13px;
	font-weight: 400;
	position: relative;
	background: white;
	display: inline-block;
}

.upload-content-padding {
	margin-top: -20px;
}

.uploaded-file {
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
</style>

<script>
export default {
	name: 'Upload',
	props: ['value', 'accept', 'readonly', 'label'],
	components: {},
	data() {
		return {
			fileData: {
				name: '',
				link: '',
				original_name: '',
				upload_id: null,
			},
			uploadInProgress: false,
			accepted: '',
		};
	},
	watch: {
		value: function () {
			this.fileData = this.$props.value;
		},
	},
	methods: {
		dropFiles(dropped) {
			if (!this.readonly) {
				this.uploadFile(dropped.dataTransfer.files[0]);
			}
		},
		uploadClick() {
			this.$refs.fileInput.click();
		},
		fileChange() {
			this.uploadFile(this.$refs.fileInput.files[0]);
		},
		uploadFile(file) {
			this.uploadInProgress = true;
			var vm = this;
			this.$APIUpload(file, (data) => {
				if (data['success']) {
					vm.fileData = data['file'];
					vm.uploadInProgress = false;
					vm.$emit('input', vm.fileData);
				}
			});
		},
		downloadClick() {
			window.open(this.fileData.link);
		},
		deleteClick() {
			var vm = this;
			this.$verify(this.$t('alerts.fileDeletionQuestion'), (result) => {
				if (result) {
					vm.fileData = {
						name: '',
						link: '',
						original_name: '',
						upload_id: null,
					};
					vm.$emit('input', vm.fileData);
					vm.$refs.fileInput.value = null;
				}
			});
		},
	},
	mounted() {
		if (this.accept !== undefined) {
			this.accepted = this.accept;
		}
		this.fileData = this.$props.value;
	},
};
</script>
